import { app } from '@ekuaibao/whispered';
export default function () {
    app.un('@vendor:download');
    app.on('@vendor:download', function (href, fileName) {
        app.sdk.download(href, fileName, true);
    });
}
